import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get } from 'lodash'

import ErrorMessage from './ErrorMessage'
import { useFormContext } from '@context/FormContext'

const Checkbox = ({ name, label, display = true, autocomplete = 'off', showPrivacyPolicy = false, ...props }) => {
  const { values, errors, submitCount, setFieldValue } = useFormContext()
  
  const fieldValue = get(values, name) || false
  const fieldError = get(errors, name)
  // Only show errors after user tries to submit (submitCount > 0)
  const fieldTouched = submitCount > 0

  if (!display) {
    return null
  }

  const handleChange = (e) => {
    const checked = e.target.checked
    setFieldValue(name, checked)
    props.onChange && props.onChange(checked)
  }

  return (
    <div
      className={classNames(
        'mb-4 flex items-start',
        { 'opacity-60': props.disabled },
        { 'border-danger': fieldError && fieldTouched },
        { 'border-success': !fieldError && fieldTouched },
      )}
    >
      <input
        {...props}
        checked={fieldValue}
        className="mt-1 h-5 w-5 text-primary-green focus:ring-2 focus:ring-primary-green/20 focus:ring-offset-2 border-gray-3 rounded cursor-pointer transition-colors"
        disabled={props.disabled}
        id={name}
        name={name}
        type="checkbox"
        onChange={handleChange}
      />

      <label className="ml-3 cursor-pointer flex-1" htmlFor={name}>
        <span className="text-gray-8 leading-relaxed">
          {label}
          {showPrivacyPolicy && (
            <a
              href="https://www.homeworksenergy.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-1 text-primary-blue hover:text-primary-blue-dark hover:underline transition-colors"
            >
              Terms & Conditions and Privacy Policy
            </a>
          )}
        </span>
      </label>

      <ErrorMessage render={!!(fieldError && fieldTouched)} message={fieldError} />
    </div>
  )
}

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  autocomplete: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onChange: PropTypes.func,
  showPrivacyPolicy: PropTypes.bool,
  display: PropTypes.bool,
  value: PropTypes.bool,
}

export default Checkbox
